type CookiePreferences = {
    necessary: true;
    analytics: boolean;
    marketing: boolean;
};

const STORAGE_KEY = "cookie-preferences";

const banner = document.getElementById("cookie-banner") as HTMLDivElement;
const prefs = document.getElementById("cookie-preferences") as HTMLDivElement;

const acceptBtn = document.getElementById("cookie-accept") as HTMLButtonElement;
const rejectBtn = document.getElementById("cookie-reject") as HTMLButtonElement;
const customizeBtn = document.getElementById(
    "cookie-customize"
) as HTMLButtonElement;
const saveBtn = document.getElementById("cookie-save") as HTMLButtonElement;

const analyticsToggle = document.getElementById(
    "toggle-analytics"
) as HTMLInputElement;
const marketingToggle = document.getElementById(
    "toggle-marketing"
) as HTMLInputElement;

function getPreferences(): CookiePreferences | null {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw) as CookiePreferences;
    } catch {
        return null;
    }
}

function setPreferences(prefs: CookiePreferences) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    updateGoogleConsent(prefs);
    hideBanner();
}

function showBanner() {
    banner.classList.remove("translate-y-full", "opacity-0");
    banner.classList.add("translate-y-0", "opacity-100");
}

function hideBanner() {
    banner.classList.add("translate-y-full", "opacity-0");
}

function togglePreferences() {
    const isClosed = prefs.style.height === "0px" || !prefs.style.height;

    if (isClosed) {
        prefs.classList.remove("opacity-0");
        prefs.classList.add("opacity-100");

        const fullHeight = prefs.scrollHeight;
        prefs.style.height = fullHeight + "px";
    } else {
        const fullHeight = prefs.scrollHeight;
        prefs.style.height = fullHeight + "px";

        prefs.getBoundingClientRect();

        prefs.style.height = "0px";
        prefs.classList.add("opacity-0");
        prefs.classList.remove("opacity-100");
    }
}

function updateGoogleConsent(prefs: CookiePreferences) {
    window.gtag?.("consent", "update", {
        analytics_storage: prefs.analytics ? "granted" : "denied",
        ad_storage: prefs.marketing ? "granted" : "denied",
        ad_user_data: prefs.marketing ? "granted" : "denied",
        ad_personalization: prefs.marketing ? "granted" : "denied",
    });
}

const saved = getPreferences();

if (!saved) {
    showBanner();
} else {
    updateGoogleConsent(saved);
}

acceptBtn.addEventListener("click", () => {
    setPreferences({ necessary: true, analytics: true, marketing: true });
});

rejectBtn.addEventListener("click", () => {
    setPreferences({ necessary: true, analytics: false, marketing: false });
});

customizeBtn.addEventListener("click", togglePreferences);

saveBtn.addEventListener("click", () => {
    setPreferences({
        necessary: true,
        analytics: analyticsToggle.checked,
        marketing: marketingToggle.checked,
    });
});
